export default __webpack_public_path__ + "static/media/fiolet_speed.babe29d3.svg";